<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Master Sertifikasi Reguler
      <template v-if="role_status && role_status.status_export_excel">
        <CButton color="info" class="btn-md ml-auto mr-2" @click="exportDataSertifikasi(idLevelAnggota)">Ekspor Excel</CButton>
      </template>
      <template v-else>
        <CButton color="secondary" class="btn-md ml-auto mr-2" disabled>Ekspor Excel</CButton>
      </template>
      <template v-if="role_status && role_status.status_create">
        <router-link to="/sertifikasi/master-sertifikasi/tambah">
          <CButton color="success" class="btn-md">Tambah</CButton>
        </router-link>
      </template>
      <template v-else>
        <CButton color="secondary" class="btn-md" disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <!-- Data Sertifikasi -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Level</label>
            <multiselect
              class="mulit-select"
              label="namaLevel"
              placeholder="Pilih Level"
              :show-labels="false"
              @select="pilihLevel"
              v-model="level"
              required
              id="selectLevel"
              :options="optionMasterLevel"
            ></multiselect>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              v-model="search"
              placeholder="Cari Data ..."
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #kode_sertifikasi="{item}">
              <td
                class="py-2 font-weight-bold"
              >{{ item.kode_sertifikasi ? item.kode_sertifikasi : '-' }}</td>
            </template>
            <template #nama_sertifikasi="{item}">
              <td class="py-2">{{ item.nama_sertifikasi ? item.nama_sertifikasi : '-' }}</td>
            </template>
            <template #nama_level="{item}">
              <td class="py-2">{{ item.nama_level ? item.nama_level : '-' }}</td>
            </template>
            <template #harga_pendaftaran="{item}">
              <td
                class="py-2"
                align="left"
              >Rp. {{ formatPrice(item.harga_pendaftaran) ? formatPrice(item.harga_pendaftaran) : '-' }}</td>
            </template>
            
            <template #jumlah_mata_uji="{item}">
              <td
                class="py-2 text-center font-weight-bold"
              >{{ item.jumlah_mata_uji ? item.jumlah_mata_uji : '-' }}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                <router-link
                  :to="'/sertifikasi/master-sertifikasi/edit/'+item.id_sertifikasi"
                  class="btn btn-sm btn-info mr-1"
                  square
                  v-c-tooltip="'Ubah'"
                >
                  <font-awesome-icon icon="edit" />
                </router-link>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Edit'" color="Secondary" class="btn-sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)" v-show="item.status_lab_test != 1">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                  <CButton v-c-tooltip="'Hapus'" color="secondary" class="btn-sm" v-show="item.status_lab_test != 1">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- end data kota/kab -->
  </CCard>
</template>
<script>
import { AlertUtils } from "@/mixins/AlertUtils";
import { Level } from "@/mixins/master/Level";
import { exportUtils } from "@/mixins/exportUtils";

import SertifikasiService from "@/services/sertifikasi/master-sertifikasi.service";

const fields = [
  { key: "no" },
  {
    key: "kode_sertifikasi",
    label: "Kode",
    _style: 'width: 7rem'
  },
  {
    key: "nama_sertifikasi",
    label: "Nama Sertifikasi"
  },
  {
    key: "nama_level",
    label: "Level"
  },
  {
    key: "harga_pendaftaran",
    label: "Biaya Pendaftaran",
    _style: "width: 15%"
  },
 
  {
    key: "jumlah_mata_uji",
    label: "Jumlah Mata Uji"
  },
  {
    key: "status",
    label: "Status Aktif",
    _style: "text-align: center"
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center"
  }
];

export default {
  name: "MasterSertifikasi",
  mixins: [AlertUtils, Level, exportUtils],
  data() {
    return {
      actionPost: "",
      fields,
      idLevelAnggota : '',
      multi_kategori: '',
      details: [],      
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      loading: true,

      level: '',
      items: [],
      currentPage: 0,
      pageSize: 10,
      search: "",
      pagination: {
        totalPages: 0
      },
      indexed: 0,

      received_messages: [],
      send_message: null,
      connected: false,
      totalNotif: 0,
      item : [],
      stompClient : null,
      socket : null,
      role_status : null,
    };
  },

  mounted() {
    /**
     * Mixins Level
     */
    this.roleData();
    this.tipe_halaman = "all_data";
    this.getAllLevel();
    setTimeout(() => {      
      this.getData(this.currentPage, this.pageSize, this.search, this.level.idLevelAnggota);
    }, 1000)    
  },

  watch: {
    search : function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
        // var searchVar = vm.ltrim(vm.search);
        var searchVar = vm.search.trimStart();
        var searchFinal = searchVar.trimEnd();
        vm.getData("0", vm.pageSize, searchFinal, vm.level.idLevelAnggota);
      }, 1000);
    },
    currentPage: function(val){      
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(val - 1, this.pageSize, this.search, this.level.idLevelAnggota);      
    }
  },
 
  methods: {
    ltrim(str) {
        if(!str) return str;
        return str.replace(/^\s+/g, '');
    },
    
    pilihLevel(value){      
      if(value.idLevelAnggota == 'default') {
        this.getData("0", this.pageSize, 'default', 'default');
      }
      this.idLevelAnggota = value.idLevelAnggota;
      this.getData("0", this.pageSize, 'default', this.idLevelAnggota);
    },

    changePageSize(e) {
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.level.idLevelAnggota);
    },
    
    pageChange() {      
      this.getData(this.currentPage, this.pageSize, this.search, this.idLevelAnggota);
    },

    deleteData(item, index) {
      var vm = this;
      vm.formData = item;
      vm.$swal.fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            SertifikasiService.deleteSertifikasi(vm.formData)
              .then(response => {                
                vm.alertDeleteSuccess();
                vm.getData("0", this.pageSize, 'default','default');
              })
              .catch(error => {
                vm.alertError(error.response.data.message);                
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter,idLevel) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      SertifikasiService.getSertifikasi(currentPage, pageSize, filter,idLevel)
        .then(response => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },    

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    
    exportDataSertifikasi(idLevelAnggota) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      SertifikasiService.exportDataSertifikasi(idLevelAnggota)
      .then(response => {
          loader.hide()
          this.exportData(response.data, 'master-sertifikasi');
          this.alertExportSuccess();
          this.getData(this.currentPage, this.pageSize, this.search, this.level.idLevelAnggota);
        })
      .catch(error => {
          loader.hide()
          this.alertExportFailed();
          this.getData(this.currentPage, this.pageSize, this.search, this.level.idLevelAnggota);
      })
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
